import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { watchForNewBuild } from './utils/freshBuild';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Offline shell — the crew work routes with dead spots, so the app has to open
// without a connection. Registered after load so it never delays first paint.
// Only in production: an unregistered dev build would serve stale bundles.
// A tab left open across deploys reloads itself for the new build the next
// time it comes to the front (laptops, mostly — phones reopen the app anyway).
if (process.env.NODE_ENV === 'production') {
  watchForNewBuild();
}

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(reg => {
      // Pick up a new build without anyone having to know to hard-refresh.
      // The owner, Sep 21 2026: "give everyone more is not there" — it was
      // there, in the bundle he was served, but his page was an older one.
      // Checked on load and whenever the app is brought back to the front,
      // which on a phone is every time it is reopened.
      const check = () => { reg.update().catch(() => {}); };
      check();
      document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
    }).catch(err => {
      console.warn('Offline shell not available:', err.message);
    });

    // A new worker took over, so the page is running last week's code: reload
    // once. The flag is what stops that turning into a loop.
    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}
